import i18n from '../../lang/index'

const userRouter = [{
  path: '/user',
  component: () => import('@/pages/Index'),
  redirect: {
    name: 'userindex'
  },
  children: [{
    name: 'userindex',
    path: 'index',
    component: () => import('@/pages/user/Index'),
    redirect: {
      name: 'userinfo'
    },
    children: [
      {
        path: 'userinfo',
        name: 'userinfo',
        meta: {
          tab: 'userinfo',
          title: i18n.t('user.myProfiletitle'),
        },
        component: () => import('@/pages/user/Userinfo'),
      },
      {
        path: 'log',
        name: 'log',
        meta: {
          tab: 'log',
          title: i18n.t('user.operationLogTitle'),
        },
        component: () => import('@/pages/user/Log'),
      },
      {
        path: 'auth',
        name: 'auth',
        meta: {
          tab: 'auth'
        },
        component: () => import('@/pages/user/Auth')
      },
      {
        path: 'bind',
        name: 'bind',
        meta: {
          tab: 'bind'
        },
        component: () => import('@/pages/user/bindAccount')
      }
    ]
  },
    {
      path: 'auth/result',
      name: 'result',
      meta: {
        tab: '',
      },
      component: () => import('@/pages/user/AuthResult'),
    },
    {
      path: 'auth/personal',
      name: 'personal',
      meta: {
        tab: '',
      },
      component: () => import('@/pages/user/Personal'),
    },
    {
      path: 'auth/personal/realName',
      name: 'realName',
      meta: {
        tab: '',
      },
      component: () => import('@/pages/user/RealName'),
    },
    {
      path: 'auth/enterprise',
      name: 'enterprise',
      meta: {
        tab: '',
      },
      component: () => import('@/pages/user/Enterprise'),
    },
    {
      path: 'auth/enterprise/bankAccount',
      name: 'bankAccount',
      meta: {
        tab: '',
      },
      component: () => import('@/pages/user/BankAccount'),
    },
    {
      path: 'auth/enterprise/license',
      name: 'license',
      meta: {
        tab: '',
      },
      component: () => import('@/pages/user/License'),
    },
    {
      path: 'auth/faceid',
      name: 'qrcode',
      meta: {
        tab: '',
      },
      component: () => import('@/pages/user/Faceid'),
    },
  ]
}]
export default userRouter



// WEBPACK FOOTER //
// ./src/router/modules/user.js